import { Stack, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ProgressContainer } from "./ProgressContainer";
import { useUserProgressWithAttributes } from "../../queries";
import { TitleTypography } from "../../styles/CommonWidgetStyles/Typography";
import { CommonWidgetContainer } from "../Commons/CommonWidgetContainer.styles";
import { WidgetSkeleton } from "../WidgetSkeleton/WidgetSkeleton.component";

export const UserProgressWidget = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { t } = useTranslation();
  const { data: userProgress, isFetching, isLoadingError, isError } = useUserProgressWithAttributes({ enabled });

  // Se c'è un errore o non ci sono dati, non renderizziamo il widget
  if (isError || isLoadingError || !userProgress) {
    return null;
  }

  const hasMandatoryCourses = userProgress?.mandatory &&
    (userProgress.mandatory.los > 0 || userProgress.mandatory.completedLos > 0);

  if ((userProgress?.attributes.length === 0) && !hasMandatoryCourses) {
    return null;
  }

  return (
    <CommonWidgetContainer hasSidePadding={ false }>
      <WidgetContainerStyle>
        <TitleTypography>{ t("your_progress") }</TitleTypography>
        { isFetching ? <WidgetSkeleton /> : (
          <ProgressContainer
            userProgress={ userProgress }
          />
        ) }
      </WidgetContainerStyle>
    </CommonWidgetContainer>
  );

};

export const WidgetContainerStyle = styled(Stack)(() => ({
  // width:"24rem"
  gap: "0.75rem"
}));
